import { Identity } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import virtual from "@pdfking/workflow/vue/3/virtual"
import contains from "rfuncs/functions/contains"
import delete_duplicates from "rfuncs/functions/delete_duplicates"
import filter from "rfuncs/functions/filter"
import group_by from "rfuncs/functions/group_by"
import key_drop from "rfuncs/functions/key_drop"
import keys from "rfuncs/functions/keys"
import length from "rfuncs/functions/length"
import map from "rfuncs/functions/map"
import merge from "rfuncs/functions/merge"
import object_map from "rfuncs/functions/object_map"
import sort from "rfuncs/functions/sort"
import to_array from "rfuncs/functions/to_array"
import { toRaw } from "vue"

import CreateStorage from "../files/providers/create"
import { DefaultBackend } from "../files/storage/DefaultBackend"
import persistence from "../utils/persistence"

const store = persistence("storage")

const backend = virtual({
  data: () => ({
    config: {},
    provider: {},
    unselected_files_names: [],
    last_session: null,
  }),
  mounted() {
    store.get().then(config => this.set_config(config, true))
  },
  methods: merge(
    object_map(
      Identity,
      k =>
        function (...input) {
          //console.info("running backend", k, input)
          const callback =
            this.provider[k] ||
            (async (...args) => console.info("unhandled", k, ...args))
          return Promise.resolve(callback(...input)).catch(error =>
            fire_event(document, "tracked_error", error)
          )
        },
      [
        "open_files",
        "open_folders",
        "add_files",
        "remove_files",
        "refresh",
        "cleanup",
      ]
    ),
    {
      set_config(spec, no_store = false) {
        const config = toRaw(spec || DefaultBackend)
        CreateStorage(config).then(provider => {
          this.config = config
          this.provider = provider
          if (!no_store) store.set(config)
          provider.populate()
        })
      },
      select_files(files) {
        this.selected_files_names = delete_duplicates(
          to_array(
            this.selected_files_names,
            map(f => f.id, to_array(files))
          )
        )
        return files
      },
      unselect_files(files) {
        this.selected_files_names = filter(
          k => !contains(files, k),
          this.selected_files_names
        )
        return files
      },
    }
  ),
  computed: {
    files() {
      return this.provider?.files || {}
    },
    selected_files() {
      return key_drop(this.files, this.unselected_files_names)
    },
    all_files_checked: {
      get() {
        const s = length(this.selected_files)
        const t = length(this.files)
        return s == t && t > 0
      },
      set(v) {
        this.unselected_files_names = v ? [] : keys(this.files)
      },
    },
    selected_files_names: {
      get() {
        return sort(keys(this.selected_files))
      },
      set(v) {
        this.unselected_files_names = keys(key_drop(this.files, v))
      },
    },

    files_by_id() {
      return group_by(this.files, "id")
    },
  },
})

export default backend
